module.exports = __webpack_public_path__ + "img/leondemo.f23a8e94.png";